import { PositionResponse } from "@/main/models/response";
import { PositionRequest } from "@/main/models/request/positionRequest";
import { IInitialReducerData } from "@/main/services/reducerUtils";

export enum PositionTypes {
	GET_POSITION = "@position/GET_POSITION",
	GET_POSITION_IDPIES = "@position/GET_POSITION_IDPIES",
	SAVE_POSITION = "@position/SAVE_POSITION",
	RESET_REDUCER_POSITION = "@position/RESET_REDUCER_POSITION",
}

export interface PositionState {
	readonly position: {
		data: PositionResponse[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
	readonly isolated: {
		[key: string]: IInitialReducerData;
	};
}

export interface GetPosition {
	type: typeof PositionTypes.GET_POSITION;
	payload: {
		request: PositionRequest;
		keyReducer: string;
	};
}

export interface GetPositionIdPIES {
	type: typeof PositionTypes.GET_POSITION_IDPIES;
	payload: {
		request: PositionRequest;
		keyReducer: string;
	};
}

export interface SavePosition {
	type: typeof PositionTypes.SAVE_POSITION;
	payload: {
		data: PositionResponse[] | null;
		isError: boolean;
		errorMessages: string[] | null;
		keyReducer: string;
	};
}

export interface ResetReducerPosition {
	type: typeof PositionTypes.RESET_REDUCER_POSITION;
	payload: {
		keyReducer: string;
	};
}

export type PositionActionTypes = GetPosition | GetPositionIdPIES | SavePosition | ResetReducerPosition;
